import { Component, OnInit, Input, DoCheck, Output, EventEmitter, IterableDiffer, IterableDiffers, ElementRef, ViewChild } from '@angular/core';
import { Filter } from 'src/app/reports/components/report/models/filter.model';
import { ReportEntity } from '../../../models/report-entity.model';
import { FilterOptionsService } from '../../filter-options/filter-options.service';
import { OpenFilterOptions } from '../../filter-options/open-filter-options.model';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit, DoCheck {

  @Input() sessionId: string;
  @Input() disabled = false;
  @Input() filters: Array<Filter> = new Array<Filter>();
  @Input() columnDragulaGroup: string;
  @Input() reportEntities: Array<ReportEntity> = [];

  @Output() filtersChange = new EventEmitter<Array<Filter>>();

  @ViewChild('containerRef') containerRef: ElementRef;

  displayedColumns: Array<string> = ['Order', 'Name', 'Legend', 'Required', 'Action'];
  differ: IterableDiffer<any>;
  isActive = false;

  constructor(private differs: IterableDiffers,
    private filterOptionService: FilterOptionsService) { }

  ngOnInit() {
    this.differ = this.differs.find(this.filters).create(null);
  }

  ngDoCheck() {
    if (this.differ.diff(this.filters)) {

      setTimeout(() => {
        this.filtersChange.emit(this.filters);
      }, 0);
    }
  }

  //#region Events

  onDeleteClick(item: Filter) {
    const aux = this.filters.concat(),
      index = aux.indexOf(item);

    if (index !== -1) {
      aux.splice(index, 1);
      this.filters = aux;
    }
  }

  onMoreOptionsClicked(event: MouseEvent, filter: Filter) {
    const obj: OpenFilterOptions = {
      event: event,
      data: filter,
      sessionId: this.sessionId
    };

    this.filterOptionService.openFilterOptions(obj);
  }

  onOrderChange(filter: Filter) {
  }

  //#endregion
}
